import { useState } from 'react';

export default function Quiz() {
  const [currentStep, setCurrentStep] = useState(0);
  const [answers, setAnswers] = useState<Record<number, string>>({});
  const [showResult, setShowResult] = useState(false);

  const questions = [
    {
      question: '평소 발에 통증을 느끼시나요?',
      options: ['자주 느낀다', '가끔 느낀다', '거의 없다', '전혀 없다']
    },
    {
      question: '하루 중 서 있거나 걷는 시간은?',
      options: ['2시간 미만', '2-4시간', '4-6시간', '6시간 이상']
    },
    {
      question: '신발을 신었을 때 어느 부분이 불편하신가요?',
      options: ['발바닥 전체', '발뒤꿈치', '발가락', '발등', '불편함 없음']
    },
    {
      question: '허리나 무릎에 통증이 있으신가요?',
      options: ['자주 있다', '가끔 있다', '거의 없다', '전혀 없다']
    }
  ];

  const handleAnswer = (answer: string) => {
    setAnswers({ ...answers, [currentStep]: answer });
    
    if (currentStep < questions.length - 1) {
      setTimeout(() => {
        setCurrentStep(currentStep + 1);
      }, 300);
    } else {
      setTimeout(() => {
        setShowResult(true);
      }, 300);
    }
  };

  const resetQuiz = () => {
    setCurrentStep(0);
    setAnswers({});
    setShowResult(false);
  };

  return (
    <section id="quiz" className="grid grid-cols-2 min-h-screen">
      {/* Left Side - Image */}
      <div className="relative bg-[#F5E6D3] overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/806c64b870cdeb8b67fb857f678de12c.jpg"
          alt="발 스캔"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/20"></div>
        
        {/* Text Overlay */}
        <div className="absolute inset-0 flex flex-col justify-between p-16">
          <p className="text-sm text-gray-700 tracking-widest uppercase">Step 01</p>
          <div>
            <h2 className="text-7xl font-bold text-gray-900 leading-none">
              나에게 맞는<br />
              맞춤형 인솔<br />
              찾기
            </h2>
          </div>
        </div>
      </div>

      {/* Right Side - Quiz Content */}
      <div className="bg-white flex items-center justify-center p-16">
        <div className="w-full max-w-xl">
          {!showResult ? (
            <div className="space-y-12">
              {/* Title */}
              <div className="text-center space-y-6">
                <h2 className="text-6xl font-bold text-gray-900 leading-tight">
                  발 건강 진단으로<br />시작하세요
                </h2>
                <p className="text-lg text-gray-500 leading-relaxed">
                  간단한 질문에 답하시면 발 유형과 자세 상태를 분석하여 최적의 인솔을 추천해드립니다
                </p>
              </div>

              {/* Progress */}
              <div className="space-y-3">
                <div className="flex justify-between text-sm text-gray-500">
                  <span>질문 {currentStep + 1} / {questions.length}</span>
                  <span>{Math.round(((currentStep + 1) / questions.length) * 100)}%</span>
                </div>
                <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
                  <div 
                    className="h-full bg-teal-500 transition-all duration-500 rounded-full"
                    style={{ width: `${((currentStep + 1) / questions.length) * 100}%` }}
                  ></div>
                </div>
              </div>

              {/* Question */}
              <div className="space-y-6">
                <h3 className="text-2xl font-bold text-gray-900">
                  {questions[currentStep].question}
                </h3>
                <div className="space-y-3">
                  {questions[currentStep].options.map((option, index) => (
                    <button
                      key={index}
                      onClick={() => handleAnswer(option)}
                      className="w-full p-5 text-left border-2 border-gray-200 rounded-2xl hover:border-teal-500 hover:bg-teal-50 transition-all cursor-pointer text-gray-700 font-medium"
                    >
                      {option}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          ) : (
            <div className="text-center space-y-8">
              <div className="w-20 h-20 bg-teal-500 rounded-full flex items-center justify-center mx-auto">
                <i className="ri-check-line text-4xl text-white"></i>
              </div>
              <div className="space-y-4">
                <h3 className="text-4xl font-bold text-gray-900">진단 완료!</h3>
                <p className="text-lg text-gray-600">
                  분석 결과, 맞춤형 인솔이 도움이 될 것으로 보입니다.<br />
                  전문 상담을 통해 더 자세한 안내를 받아보세요.
                </p>
              </div>
              <div className="flex gap-4 justify-center">
                <button
                  onClick={resetQuiz}
                  className="px-8 py-4 border-2 border-gray-300 text-gray-700 rounded-full font-semibold hover:bg-gray-50 transition-all cursor-pointer whitespace-nowrap"
                >
                  다시 진단하기
                </button>
                <button
                  onClick={() => {
                    const element = document.getElementById('contact');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="px-8 py-4 bg-teal-500 text-white rounded-full font-semibold hover:bg-teal-600 transition-all cursor-pointer whitespace-nowrap inline-flex items-center gap-2"
                >
                  상담 신청하기 <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
